const CookieFunction = (
  type,
  name,
  value,
  callback = () => console.log('cookie')
) => {
  console.log('nameeee', name);
  if (type == 'set') {
    localStorage.setItem(name, value);
    callback();
  }
  if (type == 'remove') {
    localStorage.removeItem(name);
  }
  if (type == 'get') {
    return localStorage.getItem(name) ? localStorage.getItem(name) : undefined;
  }
};

export default CookieFunction;
